import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/AuthShell";
import { useAuth, homeFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={homeFor(user)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(form.email, form.password);
      toast.success(`Selamat datang, ${u.name}`);
      nav(loc.state?.from || homeFor(u), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Masuk ke akun" subtitle="Gunakan email dan kata sandi yang terdaftar.">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div className="space-y-2"><Label htmlFor="email">Email</Label><Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="login-email-input" /></div>
        <div className="space-y-2">
          <div className="flex justify-between"><Label htmlFor="password">Kata sandi</Label><Link to="/lupa-sandi" className="text-sm text-amber-600 hover:underline" data-testid="forgot-password-link">Lupa kata sandi?</Link></div>
          <Input id="password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="login-password-input" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="w-full bg-slate-900 h-11" data-testid="login-submit-button">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Masuk</Button>
        <p className="text-sm text-slate-600 text-center">Belum punya akun? <Link to="/daftar" className="font-semibold text-slate-900 hover:underline" data-testid="login-register-link">Daftar sekarang</Link></p>
        <p className="text-center"><Link to="/" className="text-xs text-slate-500 hover:underline" data-testid="login-home-link">← Kembali ke beranda</Link></p>
      </form>
    </AuthShell>
  );
}
